__turbopack_context__.v({
  "description": "choice-card-module-scss-module__mGOHnq__description",
  "icon": "choice-card-module-scss-module__mGOHnq__icon",
  "input": "choice-card-module-scss-module__mGOHnq__input",
  "root": "choice-card-module-scss-module__mGOHnq__root",
  "title": "choice-card-module-scss-module__mGOHnq__title",
});
